<app-layout type="white" size="100%">
  <app-breadcrumb [breadcrumbItems]="[
    { label: ('breadcrumb.login' | translate), link: '/' }
  ]"></app-breadcrumb>

  <div class="content">
    <app-title title="emailConfirmed.title" />

    <p class="message">{{ 'emailConfirmed.message' | translate }}</p>

    @if (isLoggedIn === null) {
      <app-spinner></app-spinner>
    } @else if (isLoggedIn) {
      <app-button variant="primary">
        <a routerLink="/continue" queryParamsHandling="preserve">{{ 'emailConfirmed.continue' | translate }}</a>
      </app-button>
    } @else {
      <app-button variant="primary">
        <a routerLink="/" queryParamsHandling="preserve">{{ 'emailConfirmed.login' | translate }}</a>
      </app-button>
    }
  </div>
</app-layout>
